var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "v-menu",
        {
          attrs: {
            "close-on-content-click": false,
            transition: "scale-transition",
            "offset-y": "",
            "min-width": "auto",
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on, attrs }) {
                return [
                  _c(
                    "v-text-field",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            "prepend-inner-icon": _vm.icon,
                            label: _vm.label,
                            readonly: "",
                            outlined: "",
                            "hide-details": "",
                            "data-test": _vm.label + "-textField",
                          },
                          model: {
                            value: _vm.formatted,
                            callback: function ($$v) {
                              _vm.formatted = $$v
                            },
                            expression: "formatted",
                          },
                        },
                        "v-text-field",
                        attrs,
                        false
                      ),
                      on
                    )
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.showMenu,
            callback: function ($$v) {
              _vm.showMenu = $$v
            },
            expression: "showMenu",
          },
        },
        [
          _vm._v(" "),
          !_vm.disable
            ? _c("v-date-picker", {
                attrs: {
                  "active-picker": _vm.activePickerModel,
                  min: _vm.minDate,
                  max: _vm.maxDate,
                  "first-day-of-week": 1,
                  disabled: _vm.disable,
                  "data-test": _vm.label + "-datePicker",
                },
                on: {
                  "update:activePicker": function ($event) {
                    _vm.activePickerModel = $event
                  },
                  "update:active-picker": function ($event) {
                    _vm.activePickerModel = $event
                  },
                  change: function ($event) {
                    _vm.showMenu = false
                  },
                },
                model: {
                  value: _vm.datePickerModel,
                  callback: function ($$v) {
                    _vm.datePickerModel = $$v
                  },
                  expression: "datePickerModel",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }